"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SNOWFLAKE = exports.MIXPANEL = exports.INTERCOM = exports.DATADOG = void 0;
var DATADOG = exports.DATADOG = 'datadog';
var MIXPANEL = exports.MIXPANEL = 'Mixpanel';
var SNOWFLAKE = exports.SNOWFLAKE = 'Snowflake';
var INTERCOM = exports.INTERCOM = 'Intercom';